import get from 'lodash/get';
import { pageTypes } from 'constants/pageTypes';
import ApiCaller from '../ApiCaller';
import baseAjaxConfig, { headers } from '../BaseAjaxConfig';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
export var PAGE_DATA_ACTIONS;
(function (PAGE_DATA_ACTIONS) {
    PAGE_DATA_ACTIONS["REQUEST"] = "PAGE_DATA_V4_REQUEST";
    PAGE_DATA_ACTIONS["SUCCESS"] = "PAGE_DATA_V4_SUCCESS";
    PAGE_DATA_ACTIONS["ERROR"] = "PAGE_DATA_V4_ERROR";
    PAGE_DATA_ACTIONS["RENDER_SEO_PRICELIST"] = "RENDER_SEO_PRICELIST";
    PAGE_DATA_ACTIONS["CLEAR"] = "PAGE_DATA__V4_CLEAR";
    PAGE_DATA_ACTIONS["RELOAD"] = "PAGE_DATA_V4_RELOAD";
    PAGE_DATA_ACTIONS["LOAD_MORE_CONTENT_SUCCESS"] = "LOAD_MORE_CONTENT_SUCCESS";
    PAGE_DATA_ACTIONS["SET_IS_NESTED_PAGE"] = "PAGE_DATA_V4_SET_IS_NESTED_PAGE";
})(PAGE_DATA_ACTIONS || (PAGE_DATA_ACTIONS = {}));
export const TAB_ID_KEY = 'tabID';
export function renderSeoPriceList(data) {
    return {
        type: PAGE_DATA_ACTIONS.RENDER_SEO_PRICELIST,
        data
    };
}
function fdpMockStore(dispatch, pageUri, successAction, extraOptions) {
    if (pageUri === '/fdp-tracking-test-store') {
        return fetch('/fdp-mock-data').then(response => response.json().then(json => {
            const answerBoxData = get(json.RESPONSE, ['slots'], []).find(slot => {
                return Boolean(slot.widget && slot.widget.type === WidgetTypeV4.ANSWER_BOX);
            });
            if (answerBoxData && answerBoxData.widget) {
                dispatch(renderSeoPriceList(answerBoxData.widget));
            }
            return dispatch(Object.assign({ type: successAction, data: json.RESPONSE, fetchId: json['REQUEST-ID'] }, (extraOptions || {})));
        }));
    }
}
export function fetchPageDataFactory(requestAction, successAction, errorAction, _pageUri = '') {
    return function (pageUri = _pageUri, options = {}, extraOptions, requestHeaders) {
        return (dispatch) => {
            dispatch(Object.assign({ fetchOptions: {
                    pageUri,
                    options,
                    extraOptions,
                    requestHeaders
                }, url: pageUri, type: requestAction, requestContext: options }, (extraOptions || {})));
            let pageV4Headers = Object.assign({}, headers, requestHeaders);
            fdpMockStore(dispatch, pageUri, successAction, extraOptions);
            const currentPageType = get(extraOptions, ['pageType']);
            if (currentPageType === pageTypes.Home) {
                const tabId = (typeof window !== 'undefined' && window[TAB_ID_KEY]) || Math.random().toString(36).slice(7);
                pageV4Headers = Object.assign({}, pageV4Headers, {
                    'X-Tab-ID': tabId
                });
                if (extraOptions) {
                    extraOptions[TAB_ID_KEY] = tabId;
                }
            }
            return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
                headers: pageV4Headers,
                acceptErrors: true,
                pathname: '/api/4/page/fetch',
                action: requestAction
            }), Object.assign({ pageUri }, options)).then(json => {
                const answerBoxData = get(json.RESPONSE, ['slots'], []).find(slot => {
                    return Boolean(slot.widget && slot.widget.type === WidgetTypeV4.ANSWER_BOX);
                });
                if (answerBoxData && answerBoxData.widget) {
                    dispatch(renderSeoPriceList(answerBoxData.widget));
                }
                /** We'll dispatch error action when we get empty slots in the pagination call. This will help in hiding
                 the infinite page loader Multiwidgetpage **/
                if (get(options, 'pageContext.pageNumber', 0) > 1 &&
                    (!get(json, 'RESPONSE.slots') || get(json, 'RESPONSE.slots.length') === 0)) {
                    const pageMeta = get(json, 'RESPONSE.pageMeta') || {};
                    const error = {
                        message: pageMeta.pageMessage || '',
                        refreshPage: pageMeta.refreshPage || false
                    };
                    return dispatch(Object.assign({ url: pageUri, type: errorAction, error, requestContext: options }, (extraOptions || {})));
                }
                return dispatch(Object.assign({ url: pageUri, type: successAction, data: json.RESPONSE, responseHeaderObject: {
                        xReqId: json['xReqId'] || '',
                        xParentReqId: json['xParentReqId'] || '',
                        xTabId: (extraOptions && extraOptions[TAB_ID_KEY]) || ''
                    }, fetchId: json['REQUEST-ID'], requestContext: options }, (extraOptions || {})));
            }, (errorResp) => {
                const isOffline = typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && !window.navigator.onLine;
                // the `errorResp as any` aliasing is needed because the
                // `unknown` type maps to never, but that shouldn't ideally
                // be the case. The `in` check should've sufficed, but not
                // sure why it's not.
                let message = errorResp instanceof Object && 'message' in errorResp
                    ? errorResp.message
                    : stringTemplate('genericError');
                const error = {
                    message: isOffline ? stringTemplate('errortnc') : message
                };
                dispatch(Object.assign({ url: pageUri, type: errorAction, error, requestContext: options }, (extraOptions || {})));
            });
        };
    };
}
